var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-orm-simple-data',{staticClass:"mb-3",attrs:{"items":_vm.fields}})}
var staticRenderFns = []

export { render, staticRenderFns }